import "./Title.scss";

const Title = () => {
  return (
    <h1 className="title">
      <span style={{ color: "#ff99e7" }}>Q</span>
      <span style={{ color: "#99fff5" }}>U</span>
      <span style={{ color: "#ffa099" }}>I</span>
      <span style={{ color: "#99ffe5" }}>Z</span>
      <span style={{ color: "#ff99fd" }}>Z</span>
      <span style={{ color: "#99d6ff" }}>Y</span>
    </h1>
  );
};

export default Title;
